angular.module(NgAppName).constant('gVariables', {
	srcMissing: Missing_img,
	srcMissingH: Missing_img_horisontal,
	srcMissingB: Missing_img_big,
	srcMissingGallery: Missing_img_gallery,
	srcMissingSmallGrey: Missing_grey_small,
	adTypeRentalBannerLarge: 13,
	adTypeRentalBannerMed: 14,
	adTypeRentalBannerSmall: 17,
	adTypeNewDevBannerMed: 18,
	adTypeNewDevBannerLarge: 20,
	adTypeNewDevBannerSmall: 21,
	largeAdSize: 675,
	mediumAdSize: 500,
	smallAdSize: 325,
	pageId: angular.element(document.body).attr('id')
});

angular.module(NgAppName).constant('patterns', {
	'phonePattern': /^([\(\s]?\+\d{1,3}[\)\s]?)?([\d\(\)\/\s\-\.]+)(?:(?:ext|ex|x|e)\.?([\s\d]+))?$/i,
	'emailPattern': /^[a-zA-Z0-9#%&\'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9#%&\'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
	'fullnamePattern': /^[a-zA-Z.\-]{2,}(\s+[a-zA-Z.\-]{2,})+$/
});
